import React from 'react'
import { convertToSafariCompatibleDate } from 'AccountsUtils'
import './CalendarIcon.css'

const CalenderIcon = ({ dateStr }) => {
  let dateView
  if (dateStr) {
    const dateObj = new Date(convertToSafariCompatibleDate(dateStr))
    const dateString = dateObj.toString()
    dateView = (
      <div className="calendar-box flex flex-column ta-c">
        <span className="support-day">{dateString.substr(4, 3)}</span>
        <span className="support-date">{dateString.substr(8, 2)}</span>
        <span className="support-month">{dateString.substr(0, 3)}</span>
      </div>
    )
  }

  return (
    <React.Fragment>
      {dateView}
    </React.Fragment>
  )
}

export default CalenderIcon
